export default "__VITE_ASSET__fwdcw$ks__"